import { load } from './common';
import { setupObserver } from './mutation';

import BrowserIsCompatible from './browsercheck';
// Polyfill Object.assign (used for ... operator)
import 'es6-object-assign/auto';

export function embedNetscaler() {
  if (BrowserIsCompatible() ) {
    setupObserver(selectorsToWatchFor, (selector) => {
      let config = getConfig(selector);
      console.log('Found selector: ' + config.name);
      load(config);
    });
  }
}

export const selectors = [
  'vpnFormSelector',
  'containerSelector',
  'firstFieldSelector',
  'secondFieldSelector',
  'thirdFieldSelector',
  'errorSelector',
  'buttonSelector',
];

export const netscaler_base_config = {
  name: 'Base Netscaler',

  width: '320px',
  height: '480px,',

  vpnFormSelector: ['.form.insertPoint.credentialform', '[name="vpnForm"]',],
  containerSelector: [
    '.glowBoxMidPng.loginTableMidWidth', '#logonbox-logonform', '.form-container',
  ],

  firstFieldSelector: [
    '#login', '[name="login"]', '[id="Enter user name"]',
  ],
  secondFieldSelector: ['#passwd', '[name="passwd"]',],
  thirdFieldSelector: ['#passwd1', '[name="passwd1"]',],

  errorSelector: ['.CredentialTypenone .error',],

  buttonSelector: [
    '#Log_On', '#Logon', '#nsg-x1-logon-button',
  ],

  observerSelector: [
    '#Log_On', '#Logon', '#nsg-x1-logon-button',
  ],

  submit: () => {
    const button = document.querySelector(netscaler_base_config.buttonSelector);
    if (button != null) {
      button.click();
    }
    else {
      console.log('Failed to find any button to submit.');
    }
  },

  prepare: () => {},

  finalize: () => {
    try {
      window.resize();
    }
    catch (e) {
      // Netscaler version doesn't support resize
    }
  },

  hide: () => {
    // hides UI by setting a session cookie which tells the script not to render the UI
    document.cookie = 'ImprHide=1';
    window.location.assign(window.location);
  },
};

// Version: 10.5
// Themes: Default
// Type: Gateway, AAA
export const base10_5_config = {
  ... netscaler_base_config,
  name: 'Netscaler 10.5 Default',

  errorSelector: '#errorMessageLabel',

  observerSelector: '.glowBoxMidPng.loginTableMidWidth',

  prepare: () => {
    let glowBoxSelector = '.loginTableMidWidth';
    document.querySelector(glowBoxSelector).style.cssText = 'text-align: center';
  },
};

// Earlier profiles take precedence.
// For example, the netscaler_base_config selector might also be present
// in 10.5, but because base10_5_config is earlier in the list, it will be
// used when both are present.
export const selectorsToWatchFor = [
  base10_5_config.observerSelector,
  netscaler_base_config.observerSelector,
];

export function getConfig(selector) {
  switch (selector) {
  case base10_5_config.observerSelector:
    return base10_5_config;
  default:
    return netscaler_base_config;
  }
}

embedNetscaler();
